import styled from 'styled-components'


const commonSize = "1.5em"
const sizeFigma = "18px"

export const QuantityContainer = styled.div`
    display: inline-flex;
    flex-direction: row;
    align-items: center;

`

const QuantityButton = styled.button`
    padding:0px !important;
    height:40px;
    max-width: 35px;
    width: 34.8px;
    border: 2px solid #E2E2E2;
    background: transparent;
    color: #E2E2E2;
    font-weight: bold;
    outline:none;
    font-size: ${commonSize};
    cursor: pointer;
    &:active{
        color: ${props => props.color};
        border: 2px solid ${props => props.color};
    }
    

`


export const Decrease = styled(QuantityButton)<any>`
    border-radius: 4px 0px 0px 4px;
    &::after{
        content: "-";
    }
    ${(props) => {
        if (props.inneredge) {
            return 'border-right: none; color: #ADADAD;'
        }
    }}
`

export const Quantity = styled.input`
    -webkit-appearance:none;
    padding:0px !important;
    border-radius: 0px;
    margin:0px;
    width: 53px;
    height: 36px;
    border: 2px solid #E2E2E2;
    border-left: 0px;
    border-right: 0px;
    max-width: 40px;
    outline: none;
    display: flex;
    font-size: ${sizeFigma};
    padding-top: 8px;
    text-align: center;
    &:focus{
        outline: 0 none;
        border: 2px solid ${props => props.color};
        
    }
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    &[type=number] {
        -moz-appearance: textfield;
    }
`

export const Increase = styled(QuantityButton)<any>`
    border-radius: 0px 4px 4px 0px;
    &::after{
        content: "+";    
    }
    ${(props) => {
        if (props.inneredge) {
            return 'border-left: none; color: #ADADAD;'
        }
    }}
`
